import React, { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState('pt'); // Default to PT as requested by user originally

    useEffect(() => {
        const storedLanguage = localStorage.getItem('language');
        if (storedLanguage) {
            setLanguage(storedLanguage);
        } else {
            // Check browser language or default to 'pt'
            const browserLang = navigator.language.split('-')[0];
            if (browserLang === 'en' || browserLang === 'pt') {
                setLanguage(browserLang);
                localStorage.setItem('language', browserLang);
            }
        }
    }, []);

    const toggleLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem('language', lang);
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
}
